import Loading from "./Loading";
import { useBetbyRendererViewModel } from "@/betby/viewmodels/useBetbyRendererViewModel";
import type { CurrencyMode } from "@/betby/store/navStore";

interface BetbyRendererProps {
  basename?: string;
  currencyMode?: CurrencyMode;
  hideTopBar?: boolean;
}

/**
 * 封装 Betby 渲染逻辑的组件
 * 负责初始化和销毁 BTRenderer 实例，并渲染承载容器
 */
export default function BetbyRenderer({
  basename,
  currencyMode,
  hideTopBar,
}: BetbyRendererProps) {
  const { containerId, isLoading } = useBetbyRendererViewModel({
    basename,
    currencyMode,
    hideTopBar,
  });

  return (
    <>
      <Loading visible={isLoading} />
      <div id={containerId} style={{ position: "relative", top: "50px" }}></div>
    </>
  );
}
